import { render, staticRenderFns } from "./PortfolioStructureSlide.vue?vue&type=template&id=9876e9a4&lang=pug&"
import script from "./PortfolioStructureSlide.vue?vue&type=script&lang=js&"
export * from "./PortfolioStructureSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports